import cx from 'classnames';
import { Text } from 'platform-components/common';
import React from 'react';

import './spec-course-lesson-view__section-description.scss';

interface Props {
    children?: React.ReactNode | Array<React.ReactNode>;
    id?: string | null;
    mix?: string;
    values?: Record<string, any>;
}

export const SpecCourseLessonViewSectionDescription = React.memo(({ children, id, mix, values }: Props) => {
    if (!id && !children) {
        return null;
    }

    const className = cx('spec-course-lesson-view__section-description', mix);

    if (id) {
        return (
            <div className={className}>
                <Text id={id} size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN} values={values} />
            </div>
        );
    }

    return (
        <div className={className}>
            <Text size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN}>
                {children}
            </Text>
        </div>
    );
});
